// This script is added for the app - GDPR/CCPA + Cookie management

let privacyPolicyLinksTranslations = [
  { country: 'CA', language: 'en', link: 'https://naturespath.com/en-ca/pages/privacy-policy-1' },
  { country: 'CA', language: 'fr', link: 'https://naturespath.com/fr-ca/pages/privacy-policy-1' },
  { country: 'US', language: 'en', link: 'https://naturespath.com/pages/privacy-policy-1' },
  { country: 'MX', language: 'es', link: 'https://naturespath.com/es-mx/pages/privacy-policy-1' },
  { country: 'GB', language: 'en', link: 'https://naturespath.com/en-gb/pages/privacy-policy-1' },
];

function checkShopify(additionalChecks = 0) {
  if (window.isenseGDPR !== undefined && window.Shopify !== undefined && document.querySelector('.cc-link')) {
    var isense_gdpr_privacy_policy_link = document.querySelector('.cc-link');
    privacyPolicyLinksTranslations.forEach((translation) => {
      if (Shopify.country == translation['country'] && Shopify.locale == translation['language']) {
        isense_gdpr_privacy_policy_link.href = translation['link'];
      }
    });
  } else {
    setTimeout(function () {
      checkShopify(additionalChecks - 1);
    }, 1000);
  }
}

checkShopify(3);
